// Theme Editor Support
console.log('Theme Editor JS carregado!');

// Adicionar estilos CSS sempre
const style = document.createElement('style');
style.textContent = `
  /* Estilos para elementos de preview no editor */
  .slideshow__slide {
    pointer-events: auto !important;
  }
  
  product-card {
    pointer-events: auto !important;
  }
  
  scroll-carousel {
    pointer-events: auto !important;
  }
  
  slideshow-carousel {
    pointer-events: auto !important;
  }
  
  x-slideshow {
    pointer-events: auto !important;
  }
  
  .slideshow__controls button,
  .prev-next-buttons button,
  page-dots button {
    pointer-events: auto !important;
  }
  
  /* Garantir que elementos sejam clicáveis no editor */
  [data-shopify-editor-block] {
    pointer-events: auto !important;
    cursor: pointer;
  }
  
  [data-shopify-editor-block]:hover {
    outline: 2px solid #008060;
    outline-offset: 2px;
  }
  
  /* Estilos específicos para elementos customizados */
  slideshow-component {
    pointer-events: auto !important;
  }
  
  slideshow-component * {
    pointer-events: auto !important;
  }
  
  scroll-carousel * {
    pointer-events: auto !important;
  }
  
  product-card * {
    pointer-events: auto !important;
  }
  
  /* Garantir que controles de carrossel funcionem */
  .circle-button {
    pointer-events: auto !important;
  }
  
  .tap-area {
    pointer-events: auto !important;
  }
  
  /* Estilos para elementos de texto com ícones */
  .text-with-icons__item {
    pointer-events: auto !important;
  }
  
  .text-with-icons__item * {
    pointer-events: auto !important;
  }
`;
document.head.appendChild(style);
console.log('Estilos CSS adicionados!');

// Função para forçar pointer-events em elementos customizados
function forcePointerEvents() {
  const customElements = document.querySelectorAll('slideshow-carousel, x-slideshow, scroll-carousel, product-card, slideshow-component');
  customElements.forEach(element => {
    element.style.pointerEvents = 'auto';
    const children = element.querySelectorAll('*');
    children.forEach(child => {
      child.style.pointerEvents = 'auto';
    });
  });
}

// Eventos do editor
document.addEventListener('shopify:section:load', function() {
  console.log('Seção carregada');
  setTimeout(forcePointerEvents, 100);
});

document.addEventListener('shopify:block:select', function(event) {
  console.log('Bloco selecionado:', event.target);
  setTimeout(forcePointerEvents, 100);
});

document.addEventListener('shopify:block:deselect', function(event) {
  console.log('Bloco desselecionado:', event.target);
});

document.addEventListener('shopify:section:select', function() {
  console.log('Seção selecionada');
  setTimeout(forcePointerEvents, 100);
});

document.addEventListener('shopify:section:deselect', function() {
  console.log('Seção desselecionada');
});

document.addEventListener('shopify:inspector:activate', function() {
  console.log('Inspetor ativado');
  setTimeout(forcePointerEvents, 100);
});

document.addEventListener('shopify:inspector:deactivate', function() {
  console.log('Inspetor desativado');
});

// Inicializar quando o DOM estiver pronto
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function() {
    setTimeout(forcePointerEvents, 500);
  });
} else {
  setTimeout(forcePointerEvents, 500);
}

// Observar mudanças no DOM para aplicar pointer-events (MutationObserver único)
if (typeof window.themeEditorObserver === 'undefined') {
  window.themeEditorObserver = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'childList') {
        setTimeout(forcePointerEvents, 100);
      }
    });
  });

  window.themeEditorObserver.observe(document.body, {
    childList: true,
    subtree: true
  });
}

console.log('Eventos do editor configurados!');
